import React from "react";
import { EsgSettingIcon } from "assets";

export const SETTINGS_ROUTER = {
  TITLE: "Settings",
  PATH: "/settings/*",
};

export const SETTINGS_PAGE = {
  ABSOLUTE_PATH: "/settings",
  PATH: "",
  TITLE: "Settings",
  ICON: <EsgSettingIcon />,
  IS_TBD: false,
  renderMenu: false
};